import { useCallback } from 'react';
import { createErrorHandler, ApiError } from '@/utils/errorHandler';

export const useErrorHandler = () => {
  const handleError = useCallback(
    (error: ApiError, context: string = 'Operation') => {
      const handler = createErrorHandler({
        showNotification: true,
        logToConsole: true,
        reportToServer: process.env.NODE_ENV === 'production',
      });

      return handler(error, context);
    },
    []
  );

  return { handleError };
};
